import { createBrowserHistory as createHistory } from 'history';
import { LocationState } from '../types';

export const history = createHistory<LocationState>();
